import { addItems } from '@theme/cart-api';
export function studioRequestUrl(base, title, source, occasion, choices) {
  const url = new URL(base, source);
  const details = [`Design: ${title}`, `Reference: ${source}`, ...choices.filter(([, value]) => value.trim()).map(([label, value]) => `${label}: ${value.trim()}`)].join('\n');
  url.searchParams.set('design', details.slice(0, 2500));
  url.searchParams.set('occasion', occasion);
  return url.href;
}
export function studioSelectedChoices(fields) {
  return fields.filter(field => !field.disabled && (field.type !== 'radio' || field.checked)).map(field => [field.dataset.studioLabel, field.value]);
}
export function studioNeedsQuote(choices) {
  const extraChoices = ['Colour palette','Flower finish','Chocolate preference','Teddy colour','Baby-item sourcing','Sweet preference','Hoop arrangement'];
  return choices.some(([label, value]) => (extraChoices.includes(label) && /ask|other|returnable|i will supply/i.test(value)) || (label === 'Anything else we should know?' && value.trim()));
}
export function studioCartItem(id, choices) {
  return {id: Number(id), quantity: 1, properties: Object.fromEntries(choices.filter(([,v]) => v.trim()).map(([k,v])=>[k,v.trim()]))};
}
class StudioRequest extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    const fields = [...this.querySelectorAll('[data-studio-label]')];
    const choices = () => studioSelectedChoices(fields);
    const conditions = [...this.querySelectorAll('[data-studio-when-label]')];
    const photo = this.closest('.studio-pdp').querySelector('.studio-photo');
    const wording = fields.find(field => /message|wording|name|plaque/i.test(field.dataset.studioLabel));
    const sample = photo?.querySelector('[data-lettering-preview]');
    const update = () => {
      for (const group of conditions) {
        const selected = choices().find(([label]) => label === group.dataset.studioWhenLabel)?.[1];
        group.hidden = selected !== group.dataset.studioWhenValue;
        group.querySelectorAll('input, textarea, select').forEach(field => { field.disabled = group.hidden; });
      }
      this.querySelector('[data-studio-summary]').textContent = choices().filter(([, value]) => value.trim()).map(([label, value]) => `${label}: ${value.trim()}`).join(' · ') || 'Your personal touches will be saved with your order.';
      const button = this.querySelector('[data-studio-submit]');
      if (button && this.dataset.retail === 'true' && !button.disabled) button.textContent = studioNeedsQuote(choices()) ? 'Request a quote for these extras' : 'Add to cart';
      if (sample && wording) {
        photo.querySelector('[data-lettering-card]').hidden = false;
        sample.textContent = wording.value.trim() || wording.placeholder || 'Made for you';
        const lettering = choices().find(([label]) => label === 'Lettering')?.[1] || 'Modern';
        sample.className = `lettering--${lettering.toLowerCase()}`;
      }
    };
    const dialog = photo?.querySelector('[data-studio-lightbox]');
    photo?.querySelector('[data-studio-zoom]')?.addEventListener('click', () => dialog.showModal());
    photo?.querySelector('[data-studio-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    this.form.addEventListener('input', update);
    this.form.addEventListener('submit', async event => {
      event.preventDefault();
      if (this.querySelector('[data-studio-submit]')?.disabled || !this.form.reportValidity()) return;
      if (this.dataset.retail === 'true' && !studioNeedsQuote(choices())) {
        const button = this.querySelector('[data-studio-submit]');
        const error = this.querySelector('[data-studio-error]');
        button.disabled = true; button.textContent = 'Adding…'; error.hidden = true;
        try { await addItems([studioCartItem(this.dataset.variant, choices())]); }
        catch (problem) { error.textContent = problem.message; error.hidden = false; }
        finally { button.disabled = false; update(); }
        return;
      }
      window.location.assign(studioRequestUrl(this.dataset.requestUrl, this.dataset.title, this.dataset.source, this.dataset.occasion, choices()));
    });
    update();
  }
}
if (typeof customElements !== 'undefined') customElements.define('studio-request', StudioRequest);
